import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash';
 
Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
    navigator: {
      stack  : [],
      options: {}
    },
    stores: [],
    showMenu: false,
    showSelectArea: false,
    showGrepFilter: false,
    searchType: {
      type: '',
      text: ''
    },
    result: [],
    isMobile: window.innerWidth <= 813 ? true : false,
    excel: {
      date: '',
      url: ''
    },
    holiday: false,
    inputName:""
  },
  actions: {
    // 全店舗情報
    updateAllStores(context, payload) {
      context.commit('allStores', payload);
    },
    // サイドメニュー表示切り替え
    updateShowMenu(context, payload) {
      context.commit('openSide', payload);
    },
    // エリア選択ダイアログ表示切り替え
    updateShowSelectAreaDialog(context, payload) {
      context.commit('showSelectAreaDialog', payload);
    },
    // 条件絞り込みダイアログ表示切り替え
    updateShowGrepFilterDialog(context, payload) {
      context.commit('showGrepFilterDialog', payload);
    },
    
    // 検索方法アップデート
    updateSearchType(context, payload) {
      context.commit('searchType', payload);
    },
    // 検索結果アップデート
    updateResult(context, payload) {
      context.commit('result', payload);
    },
    // isMobileアップデート（画面サイズで判断）
    updateIsMobile(context, payload) {
      context.commit('isMobile', payload);
    },
    // ダウンロードエクセルデータアップデート
    updateExcel(context, payload) {
      context.commit('excel', payload);
    },
    // 祝日判定アップデート
    updateHoliday(context, payload) {
      context.commit('holiday', payload);
    },
    // 検索語句アップデート
    updateInputName(context, payload) {
      context.commit('inputName', payload);
    },
  },
  mutations: {
    push(state, page) {
      state.navigator.stack.push(page);
    },
    pop(state) {
      if (state.navigator.stack.length > 0) {
        state.navigator.stack.pop();
      }
    },
    replace(state, page) {
      state.navigator.stack.pop();
      state.navigator.stack.push(page);
    },
    reset(state, page) {
      state.navigator.stack = [page || state.navigator.stack[0]];
    },
    backTo(state, page) {
      const target_index = _.findIndex(state.navigator.stack, (item) => {
        return item.extends.name === page;
      });
 
      if (target_index >= 0) {
        const current_index = state.navigator.stack.length - 1;
        const loop = current_index - target_index;
 
        for (var i = 0; i < loop; i++) {
          state.navigator.stack.pop();
        }
      }
    },
    options(state, newOptions = {}) {
      state.options = newOptions;
    },
    allStores(state, payload) {
      state.stores = payload;
    },
    openSide(state, payload) {
      state.showMenu = payload;
    },
    showSelectAreaDialog(state, payload) {
      state.showSelectArea = payload;
    },
    showGrepFilterDialog(state, payload) {
      state.showGrepFilter = payload;
    },
    searchType(state, payload) {
      localStorage.setItem('ncbAtm.type', JSON.stringify(payload));
      state.searchType = payload;
    },
    result(state, payload) {
      localStorage.setItem('ncbAtm.result', JSON.stringify(payload));
      state.result = payload;
    },
    isMobile(state, payload) {
      state.isMobile = payload;
    },
    excel(state, payload) {
      state.excel = payload;
    },
    holiday(state, payload) {
      state.holiday = payload;
    },
    inputName(state, payload) {
      state.inputName = payload;
    }
  },
  getters  : {
    allStore(state) {
      return state.stores;
    },
    allResults(state) {
      return state.result;
    },
    searchType(state) {
      return state.searchType;
    },
    pageStacks(state) {
      return state.navigator.stack;
    },
    excel(state) {
      return state.excel;
    },
    holiday(state) {
      return state.holiday;
    },
    inputName(state) {
      return state.inputName;
    }
  },
});